<template>
  <section class="performance-page">
    <page-header></page-header>
    <main>
      <div class="month-info">
        <div class="title">
          {{ activeMonthTitle }}
        </div>

        <div class="boxes">
          <div class="box">
            <div class="month">{{ overall.totalYearCompanies }}</div>
            <div class="label">New companies</div>
            <div class="total">
              {{ overall.totalCompanies }} <span>in Total</span>
            </div>
          </div>

          <div class="box">
            <div class="month">{{ overall.totalYearContacts }}</div>
            <div class="label">New contacts</div>
            <div class="total">
              {{ overall.totalContacts }} <span>in Total</span>
            </div>
          </div>

          <div class="box">
            <div class="month">{{ overall.totalYearMeetings }}</div>
            <div class="label">New meetings</div>
            <div class="total">
              {{ overall.totalMeetings }} <span>in Total</span>
            </div>
          </div>

          <div class="box">
            <div class="month">
              {{
                (overall.totalYearContacts / overall.totalYearMeetings) | round
              }}
            </div>
            <div class="label">Contacts >> 1 Meeting</div>
            <div class="total">
              {{ (overall.totalContacts / overall.totalMeetings) | round }}
              <span>in Total</span>
            </div>
          </div>

          <div class="result">
            <div>Efficiency</div>
            <div
              class="ratio"
              :class="{
                'is-bad': overall.totalMeetings / overall.totalContacts < 0.5
              }"
            >
              {{ (overall.totalMeetings / overall.totalContacts) | round(2) }}
            </div>
          </div>
        </div>
      </div>
      <div class="filters">
        <div>
          <span class="label">Choose your interval</span>
          <el-date-picker
            ref="searchbox"
            v-model="interval"
            type="daterange"
            range-separator=" to "
            start-placeholder=" "
            end-placeholder=" "
            value-format="yyyy-MM-dd"
            placeholder="Date interval"
            prefix-icon="is-hidden"
            @change="intervalChanged()"
          >
          </el-date-picker>
        </div>
        <div>
          <span class="label">Filter by Business Manager</span>
          <el-select
            v-model="selectedManager"
            placeholder=" "
            loading-text=" "
            no-match-text=" "
            no-data-text=" "
            clearable
            filterable
            default-first-option
            value-key="value"
            @change="intervalChanged()"
          >
            <el-option
              v-for="item in managers"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="global-chart">
        <v-chart ref="chart" :options="chart" :auto-resize="true" />
      </div>

      <div class="user-charts">
        <div
          class="chart-container"
          v-for="(user, index) in users"
          :key="index"
        >
          <v-chart
            ref="chart"
            :options="user.chartSettings"
            :auto-resize="true"
          />
          <div class="info">
            <span class="name">{{ user.name }}</span>
            [{{ user.totalContacts }}:{{ user.totalMeetings }}]
          </div>
          <div class="missing">
            Debt
            <span class="state" :class="{ 'is-ok': user.state }"></span>
            <span v-if="user.missing > 0">{{ user.missing }}</span>
          </div>
        </div>
      </div>
    </main>
  </section>
</template>

<script>
import PageHeader from '@/components/PageHeader';
import _ from 'lodash';
import moment from 'moment';
import ECharts from 'vue-echarts/components/ECharts';
import 'echarts/lib/chart/bar';
import 'echarts/lib/chart/line';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/toolbox';
import 'echarts/lib/component/title';
import 'echarts/lib/component/legend';
import 'echarts/lib/component/grid';
import 'echarts/lib/component/markLine';

export default {
  name: 'Performance',
  components: {
    PageHeader,
    'v-chart': ECharts
  },
  data() {
    return {
      interval: [
        moment()
          .startOf('month')
          .format('YYYY-MM-DD'),
        moment()
          .endOf('month')
          .format('YYYY-MM-DD')
      ],
      selectedManager: '',
      chart: null,
      users: null,
      dailyTarget: 20,
      periodTarget: 0,
      overall: {
        totalYearCompanies: null,
        totalCompanies: null,
        totalYearContacts: null,
        totalContacts: null,
        totalYearMeetings: null,
        totalMeetings: null
      },
      managers: []
    };
  },
  mounted() {
    this.getMetadata();
    this.getData();
    this.getOverallData();
    this.getManagers();
  },
  computed: {
    activeMonthTitle() {
      return moment().format('MMMM YYYY');
    },
    currentChartTarget() {
      const diff_days = moment(this.interval[1]).diff(
        moment(this.interval[0]),
        'days'
      );

      if (diff_days >= 60) {
        return this.dailyTarget * 5;
      } else {
        return this.dailyTarget;
      }
    }
  },
  methods: {
    getMaxValuePerUserChart(arr) {
      let max = 0;
      arr.map(item => {
        for (const value in item.values) {
          if (item.values[value].contacts + item.values[value].meetings > max) {
            max = item.values[value].contacts + item.values[value].meetings;
          }
        }
      });
      if (max < this.dailyTarget) max = this.dailyTarget;

      return max;
    },
    intervalChanged() {
      this.getData();
    },
    getManagers() {
      this.axiosRequest('get', 'user', {
        psize: -1,
        query: '[{"field": "profile_id", "value": 5, "op": "="}]'
      })
        .then(response => {
          console.log(response);
          this.managers = response.data.data;
          //this.managers.unshift({ id: '', label: '' });
        })
        .catch(error => {
          console.log(error);
        });
    },
    getOverallData() {
      this.axiosRequest('get', 'overall')
        .then(response => {
          console.log(response);
          this.overall = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    getMetadata() {
      this.axiosRequest('get', 'metatag')
        .then(response => {
          console.log('METATAG ', response.data.data[0].contacts_per_day);
          this.dailyTarget = response.data.data[0].contacts_per_day;
        })
        .catch(error => {
          console.log(error);
        });
    },
    getData() {
      this.axiosRequest(
        'get',
        'performance?start=' +
          this.interval[0] +
          '&end=' +
          this.interval[1] +
          '&bm=' +
          this.selectedManager
      )
        .then(response => {
          const maxPerUserChart = this.getMaxValuePerUserChart(
            response.data.users
          );

          console.log(response);
          this.chart = this.setChartData(response.data.totals, '', false);

          //this.periodTarget = this.getNumWorkingDays() * this.dailyTarget;
          this.periodTarget = response.data.validDays * this.dailyTarget;

          const users_charts = [];
          response.data.users.map(item => {
            const userInfo = this.processUserInfo(item.values);

            users_charts.push({
              chartSettings: this.setChartData(
                item.values,
                item.name,
                maxPerUserChart
              ),
              name: item.name,
              totalContacts: userInfo.totalContacts,
              totalMeetings: userInfo.totalMeetings,
              state: userInfo.state,
              missing: userInfo.missing
            });
          });

          this.users = users_charts;
        })
        .catch(error => {
          console.log(error);
        });
    },
    setChartData(info, title, maxYAxis) {
      console.log(':', info, title);
      const x_series = [];
      const meetings = [];
      const contacts = [];
      const avg = [];

      for (const date in info) {
        x_series.push(date);
        meetings.push(info[date].meetings);
        contacts.push(info[date].contacts);
        avg.push(info[date].avg);
      }

      const max_meetings = _.max(meetings);
      //const max_contacts = _.max(contacts);
      let max_contacts = Number(_.max(contacts)) + Number(max_meetings);
      if (max_contacts < this.currentChartTarget)
        max_contacts = this.currentChartTarget;

      if (maxYAxis) max_contacts = maxYAxis;

      max_contacts = Number(max_contacts) + 5;
      console.log('MAX NO CHART', max_contacts, maxYAxis, title);

      return {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        toolbox: {
          feature: {
            saveAsImage: {
              show: true,
              title: ' '
            }
          }
        },
        grid: {
          bottom: 80
        },
        legend: {
          data: ['contacts', 'meetings'],
          bottom: 0
        },
        xAxis: [
          {
            type: 'category',
            data: x_series,
            axisPointer: {
              type: 'shadow'
            },
            axisLabel: {
              rotate: 45
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '' /*contacts/meetings */,
            splitLine: {
              show: true,
              lineStyle: {
                color: '#eeeeee'
              }
            },
            min: 0,
            max: max_contacts
          }
        ],
        series: [
          {
            name: 'contacts',
            type: 'bar',
            /*yAxisIndex: 0,*/
            stack: 'total',
            data: contacts,
            itemStyle: {
              color: '#2ba396'
            },
            markLine: {
              silent: true,
              lineStyle: {
                color: '#333'
              },
              symbol: 'none',
              data: [
                {
                  yAxis: this.currentChartTarget
                }
              ]
            }
          },
          {
            name: 'meetings',
            type: 'bar',
            /*yAxisIndex: 1,*/
            stack: 'total',
            data: meetings,
            itemStyle: {
              color: '#9affe9'
            }
          },
          {
            name: 'avg',
            type: 'line',
            smooth: true,
            yAxisIndex: 0,
            data: avg,
            itemStyle: {
              color: '#00513f'
            }
          }
        ]
      };
    },
    processUserInfo(info) {
      console.log(info);
      const meetings = [];
      const contacts = [];

      for (const date in info) {
        meetings.push(info[date].meetings);
        contacts.push(info[date].contacts);
      }

      const totalContacts = _.sum(contacts);
      console.log('::', this.periodTarget, totalContacts);
      let missing = 0;
      if (this.periodTarget > totalContacts)
        missing = this.periodTarget - totalContacts;

      return {
        totalContacts: totalContacts,
        totalMeetings: _.sum(meetings),
        state: this.periodTarget <= totalContacts,
        missing: missing
      };
    },
    getNumWorkingDays() {
      const startDate = new Date(this.interval[0]);
      const endDate = new Date(this.interval[1]);
      let numWorkDays = 0;
      let currentDate = new Date(startDate);
      while (currentDate <= endDate) {
        // Skips Sunday and Saturday
        if (currentDate.getDay() !== 0 && currentDate.getDay() !== 6) {
          numWorkDays++;
        }
        currentDate = currentDate.addDays(1);
      }

      return numWorkDays;
    }
  }
};
</script>

<style lang="scss" scope>
html,
body {
  overflow: auto;
}
.performance-page {
  main {
    padding: 60px;
  }
  .echarts {
    width: 100%;
    margin-top: 20px;
  }

  .user-charts {
    display: flex;
    flex-wrap: wrap;

    .chart-container {
      width: 50%;
      position: relative;
    }
  }

  .filters {
    display: flex;
    align-items: center;

    .el-date-editor {
      margin-right: 20px;
    }

    .el-date-editor .el-range-input {
      background: #ffffff;
    }

    .el-date-editor .el-range-separator {
      color: #606266;
    }

    .label {
      padding-right: 20px;
      display: inline;
      font-weight: 400;
    }
  }

  .info {
    position: absolute;
    top: 25px;
    left: 30px;
    .name {
      font-size: 1.1rem;
      padding-right: 20px;
    }
  }

  .missing {
    position: absolute;
    top: 28px;
    right: 45px;
    font-size: 0.8rem;

    .state {
      width: 10px;
      height: 10px;
      border-radius: 5px;
      background: red;
      display: inline-block;
      margin: 0 8px;

      &.is-ok {
        background: green;
      }
    }
  }

  .month-info {
    padding-bottom: 3rem;

    .title {
      text-align: left;
      color: $primary;
      font-weight: 400;
    }

    .boxes {
      display: flex;

      .box {
        margin-right: 20px;
        text-align: left;
        width: 200px;

        .month {
          opacity: 0.7;
          font-weight: $weight-bold;
          font-size: 1.5rem;
        }

        .label {
          font-size: 0.9rem;
          opacity: 0.4;
          padding: 3px 0;
          font-weight: $weight-regular;
        }

        .total {
          font-weight: $weight-bold;
          font-size: 1rem;
          border-top: solid 1px $border;
          padding-top: 2px;

          span {
            font-weight: $weight-regular;
            font-size: 0.9rem;
          }
        }
      }

      .result {
        margin-left: auto;
        text-align: center;
        width: 140px;

        .ratio {
          display: flex;
          justify-content: center;
          align-items: center;
          color: #ffffff;
          background: green;
          width: 140px;
          height: 110px;
          font-size: 1.3rem;
          font-weight: $weight-bold;
          &.is-bad {
            background: red;
          }
        }
      }
    }
  }
}
</style>
